import React from 'react';
import {
    Route, Routes, Navigate,
} from 'react-router-dom';
import { CreatePortfolioMain } from 'widgets/CreatePortfolio';
import { CreateProposalProvider } from 'datasource/ProposalManagement/CreateProposalManager';
import PortfolioRouter from './PortfolioRouter';
import { CommonAllocationProvider } from './context/CommonAllocationDataProvider';
import CreateProposalRouter from './Proposals/CreateProposalRouter';

const Router = () => (
    <CommonAllocationProvider>
        <Routes>
            <Route path=":portfolioId/*" element={<PortfolioRouter />} />
            <Route path="new-portfolio/*" element={<CreatePortfolioMain />} />
            <Route
                path="new-proposal/*"
                element={(
                    <CreateProposalProvider>
                        <CreateProposalRouter />
                    </CreateProposalProvider>
                )}
            />
            <Route
                path=""
                element={<Navigate to="new-portfolio" replace />}
            />
            <Route
                path="*"
                element={<Navigate to="/404" replace />}
            />
        </Routes>
    </CommonAllocationProvider>
);

Router.displayName = 'Router';

export default Router;
